import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { destinationsApi } from '../../api/lib/destinations';
import { destinationsKeys } from '../../api/query-keys/destinations';
import { UpdateDestinationPayload } from '../../api/types/payload/update-destination.payload';

import { ApiError } from '@/types/interfaces/api-error';

export const useUpdateDestination = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['destination']);

  return useMutation({
    mutationFn: (params: { destinationId: number; payload: UpdateDestinationPayload }) =>
      destinationsApi.updateDestination(params.destinationId, params.payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: destinationsKeys.all,
      });
      onSuccess?.();
      toast.success(t('destination:updateSuccess'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
